export const RESTAURANT_TYPE_INFO = 'INFO';
export const RESTAURANT_CREATE = 'restaurant_create';
export const RESTAURANT_VIEW = 'restaurant_view';
export const RESTAURANT_EDIT = 'restaurant_edit';
export const RESTAURANT_TYPES = 'restaurant_type';
export const RESTAURANT_TYPE_CHEF = 'CHEF';
export const RESTAURANT_CHEF_CREATE = 'restaurant_chef_create';
export const RESTAURANT_CHEF_VIEW = 'restaurant_chef_view';
export const RESTAURANT_CHEF_EDIT = 'restaurant_chef_edit';
export const CHEF_TYPE = 'chef_type';
export const DAYS = [
  { id: 1, ischecked: false, name: 'Monday', from: null, to: null },
  { id: 2, ischecked: false, name: 'Tuesday', from: null, to: null },
  { id: 3, ischecked: false, name: 'Wednesday', from: null, to: null },
  { id: 4, ischecked: false, name: 'Thursday', from: null, to: null },
  { id: 5, ischecked: false, name: 'Friday', from: null, to: null },
  { id: 6, ischecked: false, name: 'Saturday', from: null, to: null },
  { id: 7, ischecked: false, name: 'Sunday', from: null, to: null },
];
export const INFO_TAB_LIST = ['Details', 'Hours', 'Contact', 'Location', 'CTA', 'Media'];
export const CHEF_TAB_LIST = ['Details', 'Media'];
export const RESTAURANT_FILTER_CUISINE_SUBMENU = [
  { id: 'Mediterranean', name: 'Mediterranean', selected: false },
  { id: 'Asian', name: 'Asian', selected: false },
  { id: 'Continental', name: 'Continental', selected: false },
  { id: 'Mexican', name: 'Mexican', selected: false },
  { id: 'Italian', name: 'Italian', selected: false },
  { id: 'Indian', name: 'Indian', selected: false },
  { id: 'Cajun', name: 'Cajun', selected: false },
  { id: 'Thai', name: 'Thai', selected: false },
  { id: 'Lebanese', name: 'Lebanese', selected: false },
  { id: 'Chinese', name: 'Chinese', selected: false },
  {
    id: 'Contemporary British',
    name: 'Contemporary British',
    selected: false,
  },
  { id: 'Bar', name: 'Bar', selected: false },
  { id: 'Modern Peruvian', name: 'Modern Peruvian', selected: false },
  { id: 'Persian', name: 'Persian', selected: false },
  { id: 'Spanish', name: 'Spanish', selected: false },
  { id: 'Modern Chinese', name: 'Modern Chinese', selected: false },
  { id: 'International', name: 'International', selected: false },
  { id: 'American', name: 'American', selected: false },
  { id: 'Mix', name: 'Mix', selected: false },
  {
    id: 'Progressive Experimental',
    name: 'Progressive Experimental',
    selected: false,
  },
  { id: 'Japanese', name: 'Japanese', selected: false },
  { id: 'British', name: 'British', selected: false },
  { id: 'Modern Cantonese', name: 'Modern Cantonese', selected: false },
  {
    id: 'New York Steakhouse',
    name: 'New York Steakhouse',
    selected: false,
  },
  { id: 'South Asian', name: 'South Asian', selected: false },
  { id: 'European', name: 'European', selected: false },
  { id: 'Tex Mex', name: 'Tex Mex', selected: false },
  { id: 'Gourmet Burgers', name: 'Gourmet Burgers', selected: false },
  { id: 'Street Shawarma', name: 'Street Shawarma', selected: false },
  { id: 'Artisan Burgers', name: 'Artisan Burgers', selected: false },
  { id: 'Sandwiches', name: 'Sandwiches', selected: false },
  {
    id: 'Italian Mediterranean',
    name: 'Italian Mediterranean',
    selected: false,
  },
  { id: 'French', name: 'French', selected: false },
  {
    id: 'Japanese-Peruvian',
    name: 'Japanese-Peruvian',
    selected: false,
  },
  { id: 'Latin American', name: 'Latin American', selected: false },
  {
    id: 'Progressive Fine Dining',
    name: 'Progressive Fine Dining',
    selected: false,
  },
  {
    id: 'Contemporary Asian Cuisine',
    name: 'Contemporary Asian Cuisine',
    selected: false,
  },
  {
    id: 'Asian-Inspired Small Plates',
    name: 'Asian-Inspired Small Plates',
    selected: false,
  },
  {
    id: 'Cocktails and Light Dining',
    name: 'Cocktails and Light Dining',
    selected: false,
  },
  {
    id: 'Modern European Dishes',
    name: 'Modern European Dishes',
    selected: false,
  },

  // Newly Added Cuisines for Atlantis
  { id: 'Italian American', name: 'Italian American', selected: false },
  { id: 'Nordic Asian', name: 'Nordic Asian', selected: false },
  { id: 'Arabic', name: 'Arabic', selected: false },
  {
    id: 'Traditional Spanish',
    name: 'Traditional Spanish',
    selected: false,
  },
  {
    id: 'Authentic Peruvian',
    name: 'Authentic Peruvian',
    selected: false,
  },
  { id: 'Premium Cakes', name: 'Premium Cakes', selected: false },
  { id: 'French Asian', name: 'French Asian', selected: false },
  { id: 'Dessert', name: 'Dessert', selected: false },
  { id: 'Indo-French', name: 'Indo-French', selected: false },
  { id: 'Bar Appetizers', name: 'Bar Appetizers', selected: false },
  { id: 'New Wave Food Hall', name: 'New Wave Food Hall', selected: false },
  { id: 'Tea Lounge and Pâtisserie', name: 'Tea Lounge and Pâtisserie', selected: false },
  { id: 'Bar', name: 'Bar', selected: false },
  { id: 'Hawaiʻi Regional', name: 'Hawaiʻi Regional', selected: false },
  { id: 'Craft Cocktail Bar / Japanese', name: 'Craft Cocktail Bar / Japanese', selected: false },
  { id: 'Hawaiian / American', name: 'Hawaiian / American', selected: false },
  { id: 'Deli / Café', name: 'Deli / Café', selected: false },
  { id: 'Hawaiian / International', name: 'Hawaiian / International', selected: false },
  { id: 'African Style BBQ', name: 'African Style BBQ', selected: false },
  { id: 'Surf & Turf', name: 'Surf & Turf', selected: false },
  { id: 'Bistrot Style', name: 'Bistrot Style', selected: false },
  { id: 'Grab & Go', name: 'Grab & Go', selected: false },
  { id: 'Creole Cuisine', name: 'Creole Cuisine', selected: false },
  { id: 'Seafood', name: 'Seafood', selected: false },
  { id: 'Theme Buffet', name: 'Theme Buffet', selected: false },
  { id: 'Grill', name: 'Grill', selected: false },
  { id: 'Sophisticated Locavore', name: 'Sophisticated Locavore', selected: false },
  { id: 'Order Ahead', name: 'Order Ahead', selected: false },
  { id: 'Global', name: 'Global', selected: false },
  { id: 'Odia Cuisine', name: 'Odia Cuisine', selected: false },
  { id: 'Multi Cuisine', name: 'Multi Cuisine', selected: false },
];

export const RESTAURANT_FILTER_TYPE_SUBMENU = [
  { name: 'Restaurant', id: 'restaurant', selected: false },
  { name: 'Bar', id: 'bar', selected: false },
  { name: 'Rooftop Bar', id: 'rooftop_bar', selected: false },
  { name: 'Rooftop Bar & Lounge', id: 'rooftop_bar_lounge', selected: false },
  { name: 'Lobby Lounge & Bar', id: 'lobby_lounge_bar', selected: false },
  { name: 'Poolside Restaurant', id: 'poolside_restaurant', selected: false },
  { name: 'Cafe', id: 'cafe', selected: false },
  { name: 'Coffee Shop & Cafe', id: 'coffee_shop_cafe', selected: false },
  { name: 'Juice Bar', id: 'juice_bar', selected: false },
  { name: 'Frozen Treats', id: 'frozen_treats', selected: false },
  { name: 'Farmstand', id: 'farmstand', selected: false },
  { name: 'Grab & Go', id: 'grab_and_go', selected: false },
  { name: 'Beach Club', id: 'beach_club', selected: false },
  { name: 'Beer Garden', id: 'beer_garden', selected: false },
  { name: 'Farm-to-Table', id: 'farm_to_table', selected: false },
  { name: 'American Coastal', id: 'american_coastal', selected: false },
  { name: 'Hawaiian Beach Fare', id: 'hawaiian_beach_fare', selected: false },
  { name: 'Modern European', id: 'modern_european', selected: false },
  { name: 'Coastal Californian', id: 'coastal_californian', selected: false },
  { name: 'Israeli', id: 'israeli', selected: false },
  { name: 'Cafeteria', id: 'cafeteria', selected: false },
  { name: 'Coffee Shop', id: 'coffee_shop', selected: false },
  { name: 'Celebrations', id: 'celebrations', selected: false },
];

export const RESTAURANT_FILTER_STATUS_SUBMENU = [
  { id: 'active', name: 'Active', selected: false },
  { id: 'inactive', name: 'Inactive', selected: false },
];

export const RESTAURANT_FILTER = [
  {
    title: 'All',
    field: 'all',
    subMenu: [],
  },
  {
    title: 'Cuisine',
    field: 'cuisine',
    subMenu: RESTAURANT_FILTER_CUISINE_SUBMENU,
  },
  {
    title: 'Type',
    field: 'type',
    subMenu: RESTAURANT_FILTER_TYPE_SUBMENU,
  },
  {
    title: 'Status',
    field: 'isActive',
    subMenu: RESTAURANT_FILTER_STATUS_SUBMENU,
  },
];
export const TYPE_LIST = [
  { name: 'Restaurant', value: 'restaurant' },
  { name: 'Bar', value: 'bar' },
  { name: 'Rooftop Bar', value: 'rooftop_bar' },
  { name: 'Rooftop Bar & Lounge', value: 'rooftop_bar_lounge' },
  { name: 'Lobby Lounge & Bar', value: 'lobby_lounge_bar' },
  { name: 'Poolside Restaurant', value: 'poolside_restaurant' },
  { name: 'Cafe', value: 'cafe' },
  { name: 'Coffee Shop & Cafe', value: 'coffee_shop_cafe' },
  { name: 'Juice Bar', value: 'juice_bar' },
  { name: 'Frozen Treats', value: 'frozen_treats' },
  { name: 'Farmstand', value: 'farmstand' },
  { name: 'Grab & Go', value: 'grab_and_go' },
  { name: 'Beach Club', value: 'beach_club' },
  { name: 'Beer Garden', value: 'beer_garden' },
  { name: 'Farm-to-Table', value: 'farm_to_table' },
  { name: 'American Coastal', value: 'american_coastal' },
  { name: 'Hawaiian Beach Fare', value: 'hawaiian_beach_fare' },
  { name: 'Modern European', value: 'modern_european' },
  { name: 'Coastal Californian', value: 'coastal_californian' },
  { name: 'Israeli', value: 'israeli' },
  { name: 'Cafeteria', value: 'cafeteria' },
  { name: 'Coffee Shop', value: 'coffee_shop' },
  { name: 'Celebrations', value: 'celebrations'},
];
export const GRE_LIST = [
  { name: 'IP Address', value: 'ipAddress' },
  { name: 'Port', value: 'port' },
];
export const GRE_MULTI_LIST = [
  { id: 'IP Address', name: 'IP Address', selected: false },
  { id: 'Port', name: 'Port', selected: false },
];
export const CHEF_FILTER_DATA = [
  {
    title: 'All',
    field: 'all',
    subMenu: [],
  },
  {
    title: 'Restaurant',
    field: 'restaurantId',
    subMenu: [],
  },
];
export const ALL_DAY = 'all day';
export const EVERYDAY = 'everyday';

export const REDIRECT_OPTIONS = ['External URL', 'Restaurant Booking Flow'];

export const CONTACT_INFO_TYPES = [
  {
    text: 'Reviewer Information',
    value: 'REVIEWER_INFORMATION',
    title: 'Add Reviewer Title',
    valueType: 'URL',
  },
  {
    text: 'Booking URL',
    value: 'BOOKING_URL',
    title: 'Booking URL Title',
    valueType: 'URL',
  },
  {
    text: 'Social Media',
    value: 'SOCIAL_MEDIA',
    title: 'Social Media Title (Ex: Instagram / Facebook)',
    valueType: 'URL',
  },
];

export const atlantisHotelIds = [
  // the atlantis circle - dev
  '5d6f67af-f5a7-4dc1-85cf-2a128fb07267',
  // Atlantis The Palm - dev
  '7fdb97d3-eab5-4211-b796-2b7c5fbac22c',
  // Atlantis The Royal - dev
  'a44d4c62-0ee9-4680-a535-e4e85612b83b',
  // the atlantis circle - uat & stage
  'b1a2a8e7-4860-4cb4-aeaa-420accc70820',
  // Atlantis The Palm - uat & stage
  '176ea11d-e20b-47e1-8d43-4a216a214f90',
  // Atlantis The Royal - uat & stage
  '88c635dd-fd18-4411-9964-9bd13424a934',
];

export const listNames = ['primary cuisine', 'secondary cuisine'];
